module.exports = __webpack_public_path__ + "img/product.7dd4fd18.jpg";